import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/v4ward/invoice/saler/list', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/v4ward/invoice/saler/detail', Object.assign({}, options, { params }))

export const remove = (params, options) =>
request.post('/api/v4ward/invoice/saler/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/v4ward/invoice/saler/save', params,options)

export const update = (params, options) =>
request.post('/api/v4ward/invoice/saler/submit', params,options)

export const setDefault = (params, options) =>
  request.post('/api/v4ward/invoice/saler/setDefault', qs.stringify(params),options);
